import {Box, Typography} from "@mui/material";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarFilterButton,
    GridToolbarQuickFilter
} from "@mui/x-data-grid";
import CardManager from "../../../calculators/components/repeat-order/card-manager";
import {CUSTOMER_ORDERS, CUSTOMER_REFERENCES, getData} from "../../../../services/customer.service";
import React, {useContext, useEffect, useState} from "react";
import useAuth from "../../../../hooks/useAuth";
import BackendConnection from "../../../backend-connection/backend-connection";
import {logInConsole, logInConsoleObject} from "../../../../tools/debug";
import {axiosPrivate} from "../../../../api/axios";
import UserOrderDetails from "./user-order-details";
import {useTranslation} from "react-i18next";
import userProvider from "../../../../context/UserProvider";
import UserContext from "../../../../context/UserProvider";
import {useNavigate} from "react-router-dom";
import {ButtonIcapeSoftBlue} from "../../../button/button-icape";
import CalculatorAluminumContext from "../../../../context/calculatorAluminumProvider";
import CalculatorFlexContext from "../../../../context/calculatorFlexProvider";
import CalculatorHdiContext from "../../../../context/calculatorHdiProvider";
import CalculatorRigidContext from "../../../../context/calculatorRigidProvider";
import {handleClickOrderEvent} from "../../../../tools/google-tag-manager-events";

const UserQuotes = (props) => {
    const{t} = useTranslation();
    const {auth} = useAuth();
    const [connectToBackend, setConnectToBackend] = useState(false);
    const {setErrorBackendConnection} = props;
    const tabView = true;

    const { loadCustomerReferenceAluminum } = useContext(CalculatorAluminumContext);
    const { loadCustomerReferenceFlex } = useContext(CalculatorFlexContext);
    const { loadCustomerReferenceHdi } = useContext(CalculatorHdiContext);
    const { loadCustomerReferenceRigid } = useContext(CalculatorRigidContext);
    const navigate = useNavigate()

    const {dataGridLocale} = useContext(UserContext);
    const [dataGridHeight, setDataGridHeight] = useState(450);

    const [customerReferences, setCustomerReferences] = useState([]);

    const columns = [
        {field: 'pcbPartNumber', headerName: t("account.details.partNumber"), flex: 3},
        {field: 'type&technology', headerName: t("common.product"), flex: 2},
        {field: 'createdAt', headerName: t("account.details.createdAt"), flex: 1},
        {field: 'pcbQuantity', headerName: t("common.quantity"), type: 'number', flex: 1},
        {
            field: 'prices',headerName: t("common.total"),type: 'number',flex: 1,
            valueGetter: (params) => {
                const { value, row } = params;
                return `${value.fullPrice} ${row.currency.symbol}`;
            },
        },
        {field: 'orderNow', type: 'actions', flex: 2, sortable: false, align: 'center',
            renderCell: (params) => (
                <ButtonIcapeSoftBlue
                    disabled={!params.row.isValid}
                    onClick={(event) => handleOrderNowInfos(params.row.id, event)}>
                    {/*{params.row.isOrdered ? t("cta.ordered") : t("cta.orderNow") }*/}
                    {t("cta.orderNow")}
                </ButtonIcapeSoftBlue>
            ),
        },
    ];

    const [priceOfferPdf, setPriceOfferPdf] = useState('');

    //TODO create a context to have user data available at first boot
    useEffect(() => {

        let config = {headers: {"Content-Type": "application/Id+json"}};
        logInConsole(`Front syncing with DataBase : Quotes`, 'chocolate');
        (async () => {
            setConnectToBackend(true);
            try {
                const response = await getData(CUSTOMER_REFERENCES + '/customized', auth.customerId, config);

                if (response && response.length > 0) {
                    //Filter to return only quotes that are not ordered yet
                    // let customerReferencesFiltered = response.filter((reference) => {
                    //     return !reference.isOrdered;
                    // });

                    //Setting customer references with filter result
                    // setCustomerReferences(customerReferencesFiltered);
                    setCustomerReferences(response);

                    //Checking all quote received #debug
                    logInConsole(`Customer quotes received`, 'green');
                    console.log('Quotes : ', response);
                } else {
                    logInConsole(`No customer quotes found (empty)`, 'orange');
                }
            } catch (error) {
                console.log('error when obtaining customer quotes', error);
                setErrorBackendConnection(true);
            } finally {
                setConnectToBackend(false);
            }
        })();

    }, [auth.customerId])

    // UseState to handle the detail view of an order selected
    const [isReferenceSelected, setIsReferenceSelected] = useState(false);
    const [referenceSelected, setReferenceSelected] = useState('');

    // HANDLING ORDER SELECTED
    const handleQuoteSelected = (_idSelected) => {
        setConnectToBackend(true);

        logInConsole(`Quote selected : [${_idSelected}]`, 'cyan');

        logInConsole(`Asking Backend quote`, 'yellow');
        axiosPrivate.get(`${process.env.REACT_APP_BACKEND_API_BASE_URL}/shop/price-offers/` + _idSelected + '/customized')
            .then(
                (response) => {
                    logInConsole(`Quote sent by backend :`, 'chocolate');
                    console.log(response.data);

                    setReferenceSelected(response.data);
                    setConnectToBackend(false);
                    setIsReferenceSelected(true)
                    setPriceOfferPdf(response.data.priceOfferPdf);

                    logInConsole(`Quote pdf :`, 'burlywood');
                    logInConsoleObject(response.data.priceOfferPdf);
                },
                (error) => {
                    const resMessage = (error.response && error.response.data && error.response.data.message) ||
                        error.message || error.toString();
                    console.log("---> ", resMessage);
                    setErrorBackendConnection(true);
                }
            ).finally(
            () => {
                setConnectToBackend(false);
                window.scrollTo(0,0);
            }
        )
    }
    const handleOrderNowInfos = async (_quoteId, event) => {

        event?.stopPropagation();

        setConnectToBackend(true);
        logInConsole(`Quote id to order : [${_quoteId}]`, 'cyan');

        axiosPrivate.get('/shop/' + _quoteId + '/price-offer-to-order')
            .then(
                (response) => {
                    logInConsole(`PCB details sent by backend :`, 'chocolate');
                    console.log(response.data);

                    window.scrollTo({ top: 0, behavior: 'smooth' });

                    if (response.data.pcb.pcbType === 'Aluminium') {
                        loadCustomerReferenceAluminum(response.data, false, response.data.isValid);
                        navigate("/aluminum");
                    }
                    if (response.data.pcb.pcbType === 'Flex') {
                        loadCustomerReferenceFlex(response.data, false, response.data.isValid);
                        navigate("/flex");
                    }
                    if (response.data.pcb.pcbType === 'Hdi') {
                        loadCustomerReferenceHdi(response.data, false, response.data.isValid);
                        navigate("/hdi");
                    }
                    if (response.data.pcbType === 'Rigid') {
                        loadCustomerReferenceRigid(response.data, false, response.data.isValid);
                        navigate("/rigid");
                    }

                    // GTM EVENT : click_order_now
                    handleClickOrderEvent(
                        'click_order_now',
                        response.data.customPanelization,
                        response.data.pcb.pcbType,
                    );
                },
                (error) => {
                    const resMessage = (error.response && error.response.data && error.response.data.message) ||
                        error.message || error.toString();
                    console.log("---> ", resMessage);
                    setErrorBackendConnection(true);
                }
            ).finally(
            () => {
                setConnectToBackend(false);
            }
        )

        // Avoid memory leak with fetching data
        let unmounted = false;

        return () => {
            unmounted = true;
        };

    };

    const handleDLpriceOfferPdf = () => {
        window.open(process.env.REACT_APP_BACKEND_BASE_URL + '/' + priceOfferPdf);
    }

    return (
        <>
            {/*LOADING BAR BACKEND*/}
            { connectToBackend ? <BackendConnection/> : null}

            <Box className="user-content-field-wrapper">

                {
                    isReferenceSelected ?
                        <UserOrderDetails
                            priceOfferPdf = {priceOfferPdf}
                            referenceSelected={referenceSelected}
                            setIsSelected={setIsReferenceSelected}
                            handleDLpriceOfferPdf={handleDLpriceOfferPdf}
                            handleOrderNowInfos={handleOrderNowInfos}
                        />
                        :
                        <>
                            <Typography variant={"h3"}>
                                {t("account.quotes.title")}
                            </Typography>

                            {tabView ?
                                <Box sx={{height: dataGridHeight,  width: '100%'}}>
                                    <DataGrid
                                        rows={customerReferences}
                                        columns={columns}
                                        slots={{ toolbar: () => {
                                            return <GridToolbarContainer style={{justifyContent: 'flex-end', gap: '30px'}}>
                                                <GridToolbarFilterButton />
                                                <GridToolbarQuickFilter />
                                            </GridToolbarContainer>
                                        }}}
                                        disableColumnMenu
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 5 } },
                                            sorting: {sortModel: [{ field: 'createdAt', sort: 'desc' }], },
                                        }}
                                        onPaginationModelChange={(params) => {
                                            window.scrollTo(0, 0);
                                            if(params.pageSize === 5){
                                                setDataGridHeight(450);
                                                return
                                            }
                                            setDataGridHeight(params.pageSize * 52 + 147 + 52);
                                        }}
                                        pageSizeOptions={[5, 10, 25, 50]}
                                        localeText={dataGridLocale}
                                        onRowClick={element=> handleQuoteSelected(element.row.id)}
                                    />
                                </Box>
                                :
                                <CardManager data={customerReferences}/>
                            }
                        </>
                }
            </Box>
        </>
    )
}

export default UserQuotes;
